import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/case_studies/usac/01/thumbnail.jpg'

const paperInfo = {
    paperName: 'commmune導入事例_ユーザックシステム株式会社様',
    enPaperName: 'caseStudy-Usac',
    thumbnail: thumbnail,
    feature1: 'コミュニティによる解約率低減の実例',
    feature2: 'ユーザーとの距離感の近さ',
    feature3: 'カスタマーサクセスのインフラとしての活用法',
    description:
        'RPAツールやEDIシステムなどの開発・販売・保守・サポートを提供しているユーザックシステム株式会社様の事例です。活用難易度の高いBtoBソフトウェアにおけるコミュニティの活用方法の理解がより深まる資料です。',
    formSrc: 'https://go.commmune.jp/l/915341/2022-02-28/d88yy',
    type: 'pardot'
}

const WhitePaperPage = () => {
    return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
